/* eslint-disable class-methods-use-this */
/* eslint-disable no-alert */
import InputOtp from '@/components/input-otp';
import { setVCode, verityInput } from '@/utils/util-extent';

const { $ } = window;
let popupWindow;
let popupIndex = 0;
let timer;
let countTimes = 0;
const $fakeForm = $('<form></form').attr('method', 'POST').appendTo('body').hide();
const $keyInput = $('<input/>').attr('name', 'KEY').appendTo($fakeForm);
const otp = new InputOtp('#otpPhoneNumberGroup');

export default class CarResumeExtent {
  constructor() {
    const self = this;
    this.checkFormflag = true;
    this.carNoPtn = /[A-Za-z0-9]{2,4}/;
    this.mobilePtn = /[0-9]{10}/;
    this.$carNoInput1 = $('input[name="platFirst"]');
    this.$carNoInput2 = $('input[name="platLast"]');
    this.$engineInput = $('input[name="engineNumber"]');
    this.$mobileInput = $('input[name="phoneNumber"]');
    this.$vCodeInput = $('input[name="recaptcha"]');
    this.valicateInput = '';
    this.validateKey = '';
    CarResumeExtent.updateVCode();
    $('#recaptcha-reload').on('click', CarResumeExtent.updateVCode);
    $('#btn-submit').click((e) => {
      e.preventDefault();
      window.gaev('btn', 'click', 'btn_owner_carresume_download', 1);
      if (self.checkForm(false)) {
        self.checkVCode();
      }
    });

    $('#btn-comfrimopt').click((e) => {
      e.preventDefault();
      window.gaev('btn', 'click', 'btn_owner_carresume_download', 2);
      if (self.checkValidate()) self.sendValidate();
    });

    $('#btn-resendopt').click((e) => {
      e.preventDefault();
      $.fancybox.close();
      window.gaev('btn', 'click', 'btn_owner_carresume_download', 1);
      clearInterval(timer);
      countTimes = 0;
      this.stop();
      if (otp) {
        otp.reset();
      }
      if (self.checkForm(true)) self.sendForm(true);
    });

    $('btn_otherphone').click(() => {
      $('#btn-resendopt').attr('disabled', true);
      clearInterval(timer);
      countTimes = 0;
      this.stop();
      $.fancybox.close();
      if (otp) {
        otp.reset();
      }
      CarResumeExtent.updateVCode();
    });
  }

  static updateVCode(isSetFocus = false) {
    $('#recaptcha').val('');
    setVCode($('#recaptchaImg'));
    if (isSetFocus) $('#recaptcha').focus();
  }

  checkForm(isReSned) {
    let err = '';
    this.checkFormflag = false;
    if (!this.$carNoInput1.val() || !this.$carNoInput2.val()) err += '車牌號碼欄位尚未填寫，請再次確認！\r';
    else if (!this.carNoPtn.test(this.$carNoInput1.val()) || !this.carNoPtn.test(this.$carNoInput2.val())) { err += '車牌號碼 請輸入英文數字！\r'; }
    if (!this.$engineInput.val()) err += '車身/引擎欄位尚未填寫，請再次確認！\r';
    if (!this.$mobileInput.val()) err += '手機號碼欄位尚未填寫，請再次確認！\r';
    else if (!this.mobilePtn.test(this.$mobileInput.val())) err += '手機號碼格式有誤，請重新填寫！\r';
    if (verityInput(this.$engineInput.val(), 'engnum') === false) {
      err += '引擎號碼 請輸入英文數字！\r';
    }
    if (!isReSned) {
      if (!this.$vCodeInput.val()) err += '驗證碼欄位尚未填寫，請再次確認！\r';
      else if (verityInput(this.$vCodeInput.val(), 'num') === false) err += '驗證碼，請輸入數字！\r';
    }

    if (err === '') {
      this.checkFormflag = true;
    } else {
      alert(err);
    }

    return this.checkFormflag;
  }

  sendForm(isReSned) {
    $.ajax(`api/owner_carresume.ashx?t=${Date.now()}`, {
      dataType: 'json',
      type: 'POST',
      data: {
        CARNO: `${this.$carNoInput1.val().toUpperCase()}-${this.$carNoInput2.val().toUpperCase()}`,
        EGNO: this.$engineInput.val().toUpperCase(),
        MOBILE: this.$mobileInput.val(),
        vcode: isReSned ? 'ReSned' : this.$vCodeInput.val(),
      },
      success: (data) => {
        if (data.RS === 'OK') {
          console.log('OK');
          this.validateKey = data.KEY;
          $.fancybox.open({
            src: '#verifyPhoneNumber',
            type: 'inline',
            baseClass: 'fancybox-container-modal',
            touch: false,
            clickSlide: false,
            beforeShow() {
              $('#sentPhoneNumber').text($('#phoneNumber').val());
            },
            beforeClose() {
              $('#sentPhoneNumber').text('');
              if (otp) {
                otp.reset();
              }
            },
          });
          window.TheModel.scrollTop();
          clearInterval(timer);
          countTimes = 0;
          $('#btn-resendopt').attr('disabled', true);
          if (countTimes === 0) {
            this.start();
          } else {
            this.stop();
          }
          CarResumeExtent.updateVCode();
        } else {
          console.log('err');
          CarResumeExtent.updateVCode();
          alert(data.RS);
        }
      },
      error: () => {
        CarResumeExtent.updateVCode();
        alert('伺服器忙碌中，請稍候重試。謝謝！');
      },
    });
  }

  checkVCode() {
    this.sendForm(false);
    // console.log('圖形驗證');
    // $.ajax({
    //   url: 'api/vcode_vaild.ashx',
    //   type: 'POST',
    //   dataType: 'json',
    //   cache: 'false',
    //   data: {
    //     vcode: this.$vCodeInput.val(),
    //   },
    // })
    //   .done((e) => {
    //     if (e.RS === 'OK') {
    //       // console.log('圖形驗證OK');
    //       CarResumeExtent.updateVCode();
    //       this.sendForm();
    //     } else {
    //       alert(e.RS);
    //     }
    //   })
    //   .fail((e) => {
    //     console.log('error', e);
    //     alert('伺服器忙碌中，請稍候重試。謝謝！');
    //   });
  }

  checkValidate() {
    const checktmp = [];
    const valicateObj = $('input[data-input-opt]');
    valicateObj.each((index, elem) => {
      if ($(elem).val() !== '') { checktmp.push($(elem).val()); }
    });
    if (checktmp.length < 6) {
      alert('驗證碼尚未填寫完整，請再次確認！');
      return false;
    }
    this.valicateInput = checktmp.join('');
    if (this.valicateInput !== '') return true;
    alert('驗證碼尚未填寫，請再次確認！');
    return false;
  }

  sendValidate() {
    $.fancybox.close();
    clearInterval(timer);
    countTimes = 0;
    $('#btn-resendopt').attr('disabled', true);
    this.stop();
    popupIndex += 1;
    popupWindow = window.open('', `owner_carresume_result_${popupIndex}`,
      'width=1024,height=600,location=no,menubar=no,toolbar=no,status=no,scrollbars=yes,resizable=yes');
    $fakeForm.attr('action', `/owner_carresume_result.aspx?i=${popupIndex}`);
    $.ajax(`api/owner_carresume_code.ashx?t=${Date.now()}`, {
      dataType: 'json',
      type: 'POST',
      data: {
        CODE: this.valicateInput,
        KEY: this.validateKey,
      },
      success: (data) => {
        if (data.RS === 'OK') {
          $keyInput.val(data.KEY);
          $fakeForm
            .attr('target', !popupWindow ? '_blank' : `owner_carresume_result_${popupIndex}`)
            .submit();
          window.TheModel.scrollTop();
        } else {
          if (popupWindow) popupWindow.close();
          $.fancybox.close();
          alert(data.RS);
        }
      },
      error: () => {
        alert('伺服器忙碌中，請稍候重試。謝謝！');
      },
    });
  }

  start() {
    // 開啓計時器
    timer = setInterval(() => {
      countTimes += 1;
      let m = 0;
      let s = 0;
      if (countTimes > 60) { // 秒數大於60
        m = Math.floor(countTimes / 60);
        s = Math.floor(countTimes % 60);
      } else {
        m = 0;
        if (countTimes === 60) { //  秒數等於60
          s = 0;
        } else {
          s = countTimes;
        }
      }
      const timeResult = `(${this.addZero(m)}:${this.addZero(s)})`;
      $('#sp_countTimes').text(timeResult);
      if (countTimes >= 900) { // 15分鐘
        $('#btn-resendopt').attr('disabled', false);
        clearInterval(timer);
      }
    }, 1000);
  }

  stop() {
    clearTimeout(timer);
  }

  addZero(time) {
    let str = time;
    if (time < 10) {
      str = `0${time}`;
    }
    return str;
  }
}
